import React, { useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { ScheduleViewDevicesListDatatable } from "@/helpers/scheduleViewDevicesListDatatable";

function ViewDevicesModal({ open, onClose, scheduleId }) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);

  const handleLoaded = json => {
    setTotal(json.recordsTotal);
  };

  return (
    <Modal
      title={t({ defaultMessage: "设备数（{num}）" }, { num: total })}
      width={800}
      open={open}
      onClose={onClose}
      onConfirm={onClose}
    >
      <ScheduleViewDevicesListDatatable
        scheduleId={scheduleId}
        onLoaded={handleLoaded}
      />
    </Modal>
  );
}

export default ViewDevicesModal;
